// extracted by mini-css-extract-plugin
module.exports = {"centered":"PageHeader_centered__iFSiI","spaceBetween":"PageHeader_spaceBetween__pDPP8","title":"PageHeader_title__sUYN9"};